import React, { useEffect } from "react";
import AdminPortal from "./AdminPortal";
import { X } from "lucide-react";

export default function PreviewModalShell({ icon, title, subtitle, onClose, children }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AdminPortal>
      <div
        className="fixed inset-0 z-[998] flex items-center justify-center bg-black/60 p-3 backdrop-blur-sm sm:p-6"
        onClick={onClose}
      >
        <div
          className="flex max-h-[92vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-2xl"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex shrink-0 items-center justify-between gap-3 border-b border-slate-200 bg-white px-4 py-3 sm:px-5">
            <div className="flex min-w-0 items-center gap-2">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-slate-900 text-white shadow-sm ring-1 ring-black/[0.04]">
                {icon}
              </div>
              <div className="min-w-0">
                <p className="text-sm font-extrabold text-slate-900">{title}</p>
                {subtitle && <p className="truncate text-[11px] text-slate-500">{subtitle}</p>}
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-500 shadow-sm transition hover:bg-slate-50 hover:text-slate-900"
            >
              <X size={17} />
            </button>
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto bg-slate-50 p-4 sm:p-5">{children}</div>
        </div>
      </div>
    </AdminPortal>
  );
}

